import * as yup from "yup";

const idOf = (v: unknown): number | undefined =>
  v && typeof v === "object"
    ? (v as { id?: number }).id
    : undefined;

const isCity = (opts: { context?: unknown }): boolean =>
  (opts?.context as { type?: string } | undefined)?.type === "city";

const CustomReservationThresholdSchema = yup.object().shape({
  fromStation: yup
    .object()
    .nullable()
    .test(
      "from-station-required",
      "Stacioni i nisjes eshte i detyrueshem.",
      function (value: unknown) {
        if (isCity(this.options)) return true;
        return !!value;
      }
    ),

  toStation: yup
    .object()
    .nullable()
    .test(
      "to-station-required",
      "Stacioni i arritjes eshte i detyrueshem.",
      function (value: unknown) {
        if (isCity(this.options)) return true;
        return !!value;
      }
    )
    .test(
      "not-same-station",
      "Stacioni i arritjes duhet te jete i ndryshem nga nisja.",
      function (value: unknown) {
        if (isCity(this.options)) return true;
        const fromId = idOf(this.parent.fromStation);
        const toId = idOf(value);
        if (!fromId || !toId) return true;
        return fromId !== toId;
      }
    ),

  operator: yup.object().nullable(),

  fromCity: yup
    .object()
    .nullable()
    .test(
      "from-city-required",
      "Qyteti i nisjes eshte i detyrueshem.",
      function (value: unknown) {
        if (!isCity(this.options)) return true;
        return !!value;
      }
    ),

  toCity: yup
    .object()
    .nullable()
    .test(
      "to-city-required",
      "Qyteti i arritjes eshte i detyrueshem.",
      function (value: unknown) {
        if (!isCity(this.options)) return true;
        return !!value;
      }
    )
    .test(
      "not-same-city",
      "Qyteti i arritjes duhet te jete i ndryshem nga nisja.",
      function (value: unknown) {
        if (!isCity(this.options)) return true;
        const fromId = idOf(this.parent.fromCity);
        const toId = idOf(value);
        if (!fromId || !toId) return true;
        return fromId !== toId;
      }
    ),

  threshold: yup
    .number()
    .typeError("Pragu duhet te jete numer.")
    .required("Pragu eshte i detyrueshem.")
    .min(1, "Pragu duhet te jete me i madh se 0.")
});

export default CustomReservationThresholdSchema;
